import type { CmsProps } from '../../../types/cms'
import styled from '@emotion/styled'
import { Background } from '../../surfaces/background'

export const IntroducingContainer = styled(Background)<CmsProps>`
  background-color: ${({ theme, backgroundColour }) =>
    backgroundColour ?? theme.palette.silver.main};

  h2 {
    color: ${({ textColour }) => textColour ?? '#000'};
    margin-bottom: ${({ theme }) => theme.spacing(2)};
    text-align: center;
  }

  p {
    color: ${({ textColour }) => textColour ?? '#000'};
  }
`
